import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Stipend Eligibility Checking")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-5" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " Search by Registration Number ", -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " Search by Reference Code ", -1)
const _hoisted_14 = { class: "col-md-2" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " Search by NID ", -1)
const _hoisted_17 = { class: "col-md-2" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " Search by BCN ", -1)
const _hoisted_20 = { class: "col-md-2 mt-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_22 = {
  key: 0,
  class: "border-top pt-9"
}
const _hoisted_23 = {
  key: 0,
  id: "trainee_profile"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_25 = { class: "profile-info pt-1 pb-1" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-sm-3" }
const _hoisted_28 = { class: "thumbnail" }
const _hoisted_29 = {
  href: "javascript:;",
  class: "",
  title: "Entity Logo"
}
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "col-sm-9" }
const _hoisted_32 = { class: "table-responsive" }
const _hoisted_33 = { class: "table" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Registration Number")
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Reference Number")
], -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Name")
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Gender")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Father Name")
], -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Mother Name")
], -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "National ID")
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Birth Certificate Number")
], -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Date of Birth")
], -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Home District")
], -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Present Address")
], -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Permanent Address")
], -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Mobile")
], -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Alternative Mobile")
], -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Email")
], -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Religion")
], -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Highest Class Completed")
], -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, " Attendance Percentage ")
], -1)
const _hoisted_52 = { class: "block mt-5" }
const _hoisted_53 = { class: "row d-flex" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "col-5 text-start" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Eligible for stipend")
], -1)
const _hoisted_55 = { class: "col-2 text-start" }
const _hoisted_56 = {
  key: 0,
  class: "text-center text-white"
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("p", {
  class: "bg-success",
  style: {"font-weight":"bold","border-radius":"2em","height":"4.5vh","font-size":"21px"}
}, " Eligible ", -1)
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = {
  key: 1,
  class: "text-center"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("p", {
  class: "bg-danger text-white",
  style: {"font-weight":"bold","border-radius":"2em","height":"4.5vh","font-size":"20px"}
}, " Not Eligible ", -1)
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = { class: "table-responsive table-bordered" }
const _hoisted_63 = {
  class: "table",
  style: {"border":"1px solid #7da17d"}
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("thead", { style: {"border-left":"1px solid #a78951"} }, [
  /*#__PURE__*/_createElementVNode("th", {
    class: "text-center bg-success text-white",
    style: {"width":"10vw","height":"4vh","font-size":"17px","font-weight":"bold"}
  }, " Requirement "),
  /*#__PURE__*/_createElementVNode("th", {
    class: "text-center bg-success text-white",
    style: {"height":"4vh","font-size":"17px","font-weight":"bold"}
  }, " Rules "),
  /*#__PURE__*/_createElementVNode("th", {
    class: "text-center text-white bg-success",
    style: {"height":"4vh","font-size":"17px","font-weight":"bold"}
  }, " Value "),
  /*#__PURE__*/_createElementVNode("th", {
    class: "text-center text-white bg-success",
    style: {"height":"4vh","font-size":"17px","font-weight":"bold"}
  }, " Status ")
], -1)
const _hoisted_65 = { style: {"background":"#f9bcbc","border-left":"1px solid #a78951"} }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("td", { rowspan: "3" }, "Mandatory", -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("td", { class: "required" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Is Stipend Eligible Course")
], -1)
const _hoisted_68 = { style: {"background":"#f9bcbc","border-left":"1px solid #a78951"} }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("td", { class: "required" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Is Stipend Eligible Batch")
], -1)
const _hoisted_70 = { style: {"background":"#f9bcbc","border-left":"1px solid #a78951"} }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("td", { class: "required" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Has 80% attendance ")
], -1)
const _hoisted_72 = { style: {"background":"#c0b2fb","border-left":"1px solid #a78951"} }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("td", null, "Optional", -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Ethnic Group")
], -1)
const _hoisted_75 = { style: {"background":"#e1f9d8","border-left":"1px solid #a78951"} }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("td", null, "Optional", -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Physically Disabled")
], -1)
const _hoisted_78 = { style: {"background":"#c6e9e8","border-left":"1px solid #a78951"} }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("td", null, "Optional", -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Female of All District")
], -1)
const _hoisted_81 = { style: {"background":"#aaffaa","border-left":"1px solid #a78951"} }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("td", { rowspan: "3" }, "Optional", -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Poor")
], -1)
const _hoisted_84 = { style: {"background":"#aaffaa","border-left":"1px solid #a78951"} }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Permanent Address")
], -1)
const _hoisted_86 = { style: {"background":"#aaffaa","border-left":"1px solid #a78951"} }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Income Certificate")
], -1)
const _hoisted_88 = ["href"]
const _hoisted_89 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-file",
  style: {"font-size":"20px","color":"green"}
}, null, -1)
const _hoisted_90 = [
  _hoisted_89
]
const _hoisted_91 = /*#__PURE__*/_createElementVNode("p", { style: {"font-weight":"bold"} }, " N.B: In addition to the mandatory rules, at least one optional rule must be followed to qualify the Stipend Eligibility. ", -1)
const _hoisted_92 = {
  key: 1,
  class: "text-center"
}
const _hoisted_93 = /*#__PURE__*/_createElementVNode("h4", null, "No data found!", -1)
const _hoisted_94 = [
  _hoisted_93
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trainee.registration_number) = $event)),
                    placeholder: "Search"
                  }, null, 512), [
                    [_vModelText, _ctx.trainee.registration_number]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.trainee.reference_number) = $event)),
                    placeholder: "Search"
                  }, null, 512), [
                    [_vModelText, _ctx.trainee.reference_number]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.trainee.nid) = $event)),
                    placeholder: "Search"
                  }, null, 512), [
                    [_vModelText, _ctx.trainee.nid]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.trainee.bcn) = $event)),
                    placeholder: "Search"
                  }, null, 512), [
                    [_vModelText, _ctx.trainee.bcn]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getTraineeInfo())),
                  type: "button",
                  class: "btn btn-success mt-6 p-3",
                  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                }, [
                  _createTextVNode(" Search "),
                  _hoisted_21
                ])
              ])
            ]),
            (this.showTraineeInfo)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_22, [
                  (_ctx.traineeInfo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("h2", null, "Trainee name: " + _toDisplayString(_ctx.traineeInfo.trainee_name), 1),
                        _hoisted_24,
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("a", _hoisted_29, [
                                  _createElementVNode("img", {
                                    class: "d-flex justify-content-center h-100 w-100",
                                    src: 
                              _ctx.traineeInfo?.attach_file_info?.file_path
                                ? _ctx.api_url +
                                  _ctx.traineeInfo?.attach_file_info?.file_path
                                : 'media/avatars/blank.png'
                            ,
                                    alt: ""
                                  }, null, 8, _hoisted_30)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("table", _hoisted_33, [
                                  _createElementVNode("tbody", null, [
                                    _createElementVNode("tr", null, [
                                      _hoisted_34,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.registration_number), 1),
                                      _hoisted_35,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.reference_number), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_36,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.trainee_name), 1),
                                      _hoisted_37,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.gender), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_38,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.father_name), 1),
                                      _hoisted_39,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.mother_name), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_40,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.nid), 1),
                                      _hoisted_41,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.bcn), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_42,
                                      _createElementVNode("td", null, " : " + _toDisplayString(_ctx.moment(_ctx.traineeInfo.date_of_birth).format(
                                    'DD-MM-YYYY'
                                  )), 1),
                                      _hoisted_43,
                                      _createElementVNode("td", null, " : " + _toDisplayString(_ctx.traineeInfo.home_district_info
                                    ?.district_name_eng), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_44,
                                      _createElementVNode("td", null, ":" + _toDisplayString(_ctx.traineeInfo.present_address), 1),
                                      _hoisted_45,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.per_address), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_46,
                                      _createElementVNode("td", null, ":" + _toDisplayString(_ctx.traineeInfo.mobile), 1),
                                      _hoisted_47,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.alternative_mobile), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_48,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.email), 1),
                                      _hoisted_49,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.religion), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_50,
                                      _createElementVNode("td", null, " : " + _toDisplayString(_ctx.traineeInfo.highest_class_completed), 1),
                                      _hoisted_51,
                                      _createElementVNode("td", null, " :" + _toDisplayString(_ctx.traineeInfo?.attendance_percentage) + "% ", 1)
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("div", _hoisted_53, [
                              _hoisted_54,
                              _createElementVNode("div", _hoisted_55, [
                                (this.stipendEligibleSTatus == 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, _hoisted_58))
                                  : _createCommentVNode("", true),
                                (this.stipendEligibleSTatus == 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_59, _hoisted_61))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_62, [
                              _createElementVNode("table", _hoisted_63, [
                                _hoisted_64,
                                _createElementVNode("tbody", null, [
                                  _createElementVNode("tr", _hoisted_65, [
                                    _hoisted_66,
                                    _hoisted_67,
                                    _createElementVNode("td", null, _toDisplayString(_ctx.traineeInfo?.course_info?.course_name), 1),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.traineeInfo?.course_info?.isStipendCourse == 1
                                  ? 'Yes'
                                  : 'No'), 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_68, [
                                    _hoisted_69,
                                    _createElementVNode("td", null, _toDisplayString(_ctx.traineeInfo?.batch_info?.batch_number), 1),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.traineeInfo?.course_info?.isStipendCourse == 1
                                  ? 'Yes'
                                  : 'No'), 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_70, [
                                    _hoisted_71,
                                    _createElementVNode("td", null, _toDisplayString(_ctx.traineeInfo?.attendance_percentage >= 80
                                  ? _ctx.traineeInfo?.attendance_percentage
                                  : 'No'), 1),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.traineeInfo?.attendance_percentage >= 80
                                  ? 'Yes'
                                  : 'No'), 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_72, [
                                    _hoisted_73,
                                    _hoisted_74,
                                    _createElementVNode("td", null, _toDisplayString(_ctx.traineeInfo?.ethnic_group_info?.group_name), 1),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.traineeInfo?.ethnic_group != 'null' &&
                                _ctx.traineeInfo?.ethnic_group == 1
                                  ? 'No'
                                  : 'Yes'), 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_75, [
                                    _hoisted_76,
                                    _hoisted_77,
                                    _createElementVNode("td", null, _toDisplayString(_ctx.traineeInfo?.is_physically_challenged), 1),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.traineeInfo?.is_physically_challenged), 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_78, [
                                    _hoisted_79,
                                    _hoisted_80,
                                    _createElementVNode("td", null, _toDisplayString(_ctx.traineeInfo?.permanent_district_info
                                  ?.district_name_eng), 1),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.traineeInfo?.gender == 'Female' ? 'Yes' : 'No'), 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_81, [
                                    _hoisted_82,
                                    _hoisted_83,
                                    _createElementVNode("td", null, _toDisplayString(_ctx.traineeInfo?.is_poor ? 'Yes' : 'No'), 1),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.traineeInfo?.is_poor ? 'Yes' : 'No'), 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_84, [
                                    _hoisted_85,
                                    _createElementVNode("td", null, _toDisplayString(_ctx.traineeInfo?.per_address), 1),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.traineeInfo?.per_address != '' ? 'Yes' : 'No'), 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_86, [
                                    _hoisted_87,
                                    _createElementVNode("td", null, [
                                      (
                                  _ctx.traineeInfo?.income_certificate?.file_name
                                )
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            href: `${this.api_url}${_ctx.traineeInfo?.income_certificate?.file_name}`,
                                            target: "_blank"
                                          }, _hoisted_90, 8, _hoisted_88))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createTextVNode(" No ")
                                          ], 64))
                                    ]),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.traineeInfo?.income_certificate?.file_name !=
                                null
                                  ? 'Yes'
                                  : 'No'), 1)
                                  ])
                                ])
                              ]),
                              _hoisted_91
                            ])
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_92, _hoisted_94))
                ])), [
                  [_directive_loading, _ctx.load]
                ])
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}